import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../../assets/location.png';
var _hoisted_1 = { class: "bike-lane-info-card" };
var _hoisted_2 = { class: "bike-lane-name" };
var _hoisted_3 = { class: "bike-lane-info" };
var _hoisted_4 = { class: "bike-lane-distance" };
var _hoisted_5 = { class: "bike-lane-location" };
var _hoisted_6 = /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_0,
    alt: "地標圖"
}, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.info.RouteName), 1),
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.info.Direction) + " " + _toDisplayString(_ctx.filterDistance(_ctx.info.CyclingLength)) + "公里", 1),
            _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createTextVNode(" " + _toDisplayString(_ctx.info.City) + " " + _toDisplayString(_ctx.info.Town), 1)
            ])
        ])
    ]));
}
